<template>
  <div class="inner--sides">
    <h3 class="prompt">{{ stakeholderPrompt1 }}</h3>
    <lookup-form/>
    <opt-in-form/>
  </div>
</template>
<script>
import { mapState } from "vuex";
import LookupForm from "WhoDoYouKnowComponents/forms/LookupForm.vue";
import OptInForm from "WhoDoYouKnowComponents/forms/OptInForm.vue";

export default {
  name: "LookupStakeholders",
  components: {
    LookupForm,
    OptInForm
  },
  computed: {
    ...mapState("campaign", {
      stakeholderPrompt1: state => state.contentStakeholderSearchPrompt1
    })
  }
};
</script>
